
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.051 2.996L4.2 10.213a2.529 2.529 0 00-.559 1.183l-.309 2.7a1.272 1.272 0 001.561 1.471l2.687-.457a2.4 2.4 0 001.16-.623l6.851-7.224c1.185-1.246 1.719-2.667-.125-4.4-1.836-1.724-3.23-1.118-4.415.133z","fill":"none","stroke":"#b6b7bb","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"data-name":"Vector","d":"M9.917 4.212a5.09 5.09 0 004.529 4.279M2.493 18.338h15.014","fill":"none","stroke":"#b6b7bb","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}})])
          )
        }
      }
    